import React, { useEffect } from "react";
import { toast } from "react-hot-toast";
import MetaData from "../../components/layout/MetaData";
import Hero from "./Hero";
import FeaturedCategories from "./FeaturedCategories";
import FeaturedProducts from "./FeaturedProducts";
import AboutCreatyea from "./AboutCreatyea";
import SubscribeNewsletter from "./SubscribeNewsletter";
import { useGetProductsQuery } from "../../redux/api/productsApi";
import Loader from "../../components/Loader";

const HomePage = () => {
  const { data , isLoading, isError, error } = useGetProductsQuery();
  const { data:products } = data || [];
  

 useEffect(() => {
   if (isError) {
     toast.error(error?.data?.message);
   }
 }, [isError, error?.data?.message]);
  
  if (isLoading) {
    return <Loader />;
  }
  
  
  return (
    <>
      <MetaData title={"Buy Best Products Online"} />
      <Hero />
      <FeaturedCategories />  
      <FeaturedProducts products={products} />
      <AboutCreatyea />
      <SubscribeNewsletter />
    </>
  );
};

export default HomePage;
